import React from 'react';
import ModelEntity from "../../../../../model2/model-entity";
import FieldDropdownLazyLoading from "../../dropdown-lazy-loading";
import FieldDropdownLazyLoading_FormValueLoading from "./value-loading";

type Props = {
    field           : FieldDropdownLazyLoading,
    value?          : any,
    model?          : ModelEntity           // some dropdowns need model to build options i.e. taskAssignee is based on projectId

    configOptions?  : any
    disabled?       : boolean,

    onChange?       : onChangeCallback,

    className?      : string
}

type State = {
    initialPropsValue   : any
    currentOption       : any
    showPopover         : boolean
    isLoaded            : boolean
}

// const debug = "FieldDropdownLazyLoading_FormView"
const debug = false

export default class FieldDropdownLazyLoading_FormView extends React.Component<Props,State> {

    constructor(props:Props) {
        super(props);

        this.state = {
            isLoaded            : this.props.field.isLoaded,
            initialPropsValue   : props.value, // required to check if currentOption update needed on props changed
            currentOption       : props.field._getOption(props.value),
            showPopover         : false,
        }
    }

    static getDerivedStateFromProps(props:Props, state:State) {
        if (props.value !== state.initialPropsValue) {
            return {
                initialPropsValue: props.value,
                currentOption: props.field._getOption(props.value)
            }
        } else {
            return state
        }
    }

    onLoaded = () => {
        // currentOption was resolved in the constructor, when there were no
        // options yet — a stored value came back as `false` there. Without
        // recomputing it here the field renders as empty although it has a
        // value, which is the whole point of a lazy dropdown.
        this.setState({
            isLoaded        : true,
            currentOption   : this.props.field._getOption(this.props.value)
        })
    }

    showPopover = (e?:React.SyntheticEvent) => {
        e?.stopPropagation()

        if (!this.state.showPopover && !this.props.disabled) this.setState({showPopover: true})
    }
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    onOptionClick = (option:any) => {
        if (!option || (_.isNil(option.value) && !this.props.field.hasOptionWithNullValue)) option = null;

        this.setState({
            currentOption: option
        }, () => {
            if (this.props.onChange) this.props.onChange(_.get(option, 'value', null));
            this.hidePopover()
        });
    }

    render() {
        const {field}   = this.props;

        const classes   = Classes(this.props.className, {
            'show-popover'  : this.state.showPopover,
            'is-disabled'   : this.props.disabled
        });

        if (!this.state.isLoaded) {

            debug && console.log(debug, "not loaded -> process loading")

            field.loadOptions(this.onLoaded)

            return <FieldDropdownLazyLoading_FormValueLoading className       = {classes}
                                                              field           = {field}
                                                              configOptions   = {this.props.configOptions}
                                                              disabled        = {this.props.disabled}
                                                              />
        }

        debug && console.log(debug, "loaded... field=", field)

        // Value selected
        // need check value because of none
        if (this.state.currentOption && (field.hasOptionWithNullValue || !_.isNil(this.state.currentOption.value))) {

            return (
                <field.components.FormValueNotEmpty className       = {classes}
                                                    field           = {field}
                                                    option          = {this.state.currentOption}
                                                    configOptions   = {this.props.configOptions}
                                                    disabled        = {this.props.disabled}
                                                    onClick         = {this.showPopover}
                                                    onOptionClick   = {this.onOptionClick}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </field.components.FormValueNotEmpty>
            );
        }

        // has initial value
        if (!this.state.currentOption && this.state.initialPropsValue && (field.hasOptionWithNullValue || !_.isNil(this.state.currentOption.value))) {
            const currentOption = this.props.field._getOption(this.props.value)
            return (
                <field.components.FormValueNotEmpty className       = {classes}
                                                    field           = {field}
                                                    option          = {currentOption}
                                                    configOptions   = {this.props.configOptions}
                                                    disabled        = {this.props.disabled}
                                                    onClick         = {this.showPopover}
                                                    onOptionClick   = {this.onOptionClick}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </field.components.FormValueNotEmpty>
            );
        }

        // No value selected
        return (
            <field.components.FormValueEmpty className      = {classes}
                                             field          = {field}
                                             configOptions  = {this.props.configOptions}
                                             disabled       = {this.props.disabled}
                                             onClick        = {this.showPopover}>
                {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
            </field.components.FormValueEmpty>
        );
    }
}
